import { ImageUpload } from '#assets/svg';
import { produce } from 'immer';
import { FileUpload } from 'src/shared/components/file-upload/FileUpload';
import { useRecordImagesRecoil } from '../states/recordImagesState';

export const TotalExerciseMedia = ({}) => {
  const { setRecordImages } = useRecordImagesRecoil();

  const onUploadFileComplete = (id: string) => {
    setRecordImages(
      produce(draft => {
        draft.push(id);
      })
    );
  };

  const onRemoveFileComplete = (id: string) => {
    setRecordImages(prev => prev.filter(fileId => fileId !== id));
  };

  return (
    <FileUpload
      maxCountMsg={''}
      path={'exercise-image'}
      fileType={'.jpg,.jpeg,.png,.mp4,.mov,.svg'}
      // onChange={onChange}
      maxCount={5}
      onUploadFileComplete={onUploadFileComplete}
      onDeleteFileComplete={onRemoveFileComplete}
    >
      <ImageUpload />
    </FileUpload>
  );
};
